import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../../Components/Separator/BMXSeparator";
import { useSelector } from "react-redux";
const SettingsModalFormStepThree = (props) => {
    const user = useSelector((state) => state.userSession.user);
    const { t } = useTranslation();
    return (
        <div>
            <Col>
                <Row>
                    <Col>
                        <BMXSeparator
                            title={t("global:settings.receivedDocuments")}
                        ></BMXSeparator>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Field
                            data-cy="EMAIL_CONFIRM_DOCUMENT_RECEIVED"
                            name="EMAIL_CONFIRM_DOCUMENT_RECEIVED.value"
                            component={BMXTextField}
                            label={t("global:settings.emailConfirmDocumentReceived")}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <BMXSeparator title={t("global:settings.emailFVData")} />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Field
                            data-cy="SMTP_FAVAT_REPORT_SERVER"
                            name="SMTP_FAVAT_REPORT_SERVER.value"
                            component={BMXTextField}
                            label={t("global:settings.SMTP_FAVAT_REPORT_SERVER")}
                        />
                    </Col>
                    <Col md={6}>
                        <Field
                            data-cy="SMTP_FAVAT_REPORT_LOGIN"
                            name="SMTP_FAVAT_REPORT_LOGIN.value"
                            component={BMXTextField}
                            label={t("global:settings.SMTP_FAVAT_REPORT_LOGIN")}
                        />
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <Field
                            data-cy="SMTP_FAVAT_REPORT_PASS"
                            name="SMTP_FAVAT_REPORT_PASS.value"
                            type="password"
                            component={BMXTextField}
                            label={t("global:settings.SMTP_FAVAT_REPORT_PASS")}
                        />
                    </Col>
                    <Col md={6}>
                        <Field
                            data-cy="SMTP_FAVAT_REPORT_PORT"
                            name="SMTP_FAVAT_REPORT_PORT.value"
                            component={BMXTextField}
                            label={t("global:settings.SMTP_FAVAT_REPORT_PORT")}
                        />
                    </Col>
                </Row>
            </Col>
        </div>
    );
};

export default SettingsModalFormStepThree;
